const BUYLINK_EXPIRE_DATE_PATTERN = /^\d{8}$/;

export type BuyLinkExpiryStatus =
  | "EXPIRING_TODAY"
  | "EXPIRED"
  | "FUTURE"
  | "UNKNOWN";

export const normalizeBuyLinkExpireDate = (value: unknown): string => {
  const normalized = String(value ?? "").trim();
  if (!BUYLINK_EXPIRE_DATE_PATTERN.test(normalized)) return "";
  const year = Number(normalized.slice(0, 4));
  const month = Number(normalized.slice(4, 6));
  const day = Number(normalized.slice(6, 8));
  const parsed = new Date(Date.UTC(year, month - 1, day));
  if (
    parsed.getUTCFullYear() !== year ||
    parsed.getUTCMonth() + 1 !== month ||
    parsed.getUTCDate() !== day
  ) {
    return "";
  }
  return normalized;
};

export const formatBuyLinkExpireDateKo = (value: unknown): string => {
  const normalized = normalizeBuyLinkExpireDate(value);
  if (!normalized) return "";
  return `${Number(normalized.slice(0, 4))}년 ${Number(
    normalized.slice(4, 6)
  )}월 ${Number(normalized.slice(6, 8))}일`;
};

export const getBuyLinkExpiryStatus = (
  value: unknown,
  seoulDateKey: string
): BuyLinkExpiryStatus => {
  const normalized = normalizeBuyLinkExpireDate(value);
  const today = String(seoulDateKey || "").replace(/-/g, "");
  if (!normalized || !BUYLINK_EXPIRE_DATE_PATTERN.test(today)) return "UNKNOWN";
  if (normalized === today) return "EXPIRING_TODAY";
  return normalized < today ? "EXPIRED" : "FUTURE";
};
